import ActTeam from './ActTeam';

export default ActTeam;
